module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media mb-1"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object rounded",
    attrs: {
      "src": require('@/assets/abeja_logo1.png'),
      "width": "50",
      "height": "50",
      "alt": _vm.item.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('strong', {
    staticClass: "d-block"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('span', [_vm._v("Quantity: " + _vm._s(_vm.item.quantity) + " - " + _vm._s(_vm._f("formatMoney")(_vm.item.price)))])]), _vm._v(" "), _c('div', {
    staticClass: "media-right align-middle"
  }, [_c('remove-from-cart', {
    attrs: {
      "product": _vm.item
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec26f802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/shopping-cart/ShoppingCartItem.vue
// module id = 277
// module chunks = 1